import type { ReactNode } from 'react';
import { ALLOCATIONS_DRAFT, ALLOCATIONS_FINAL, ALLOCATIONS_PUBLISHED } from 'common/constants/allocations';
import type { SecondaryNavigationStatusBadgeTone } from './SecondaryNavigation.types';

export const SECONDARY_NAVIGATION_STATUS_BADGE_EXIT_MS = 80;
export const SECONDARY_NAVIGATION_STATUS_BADGE_ENTER_MS = 120;

export const createSecondaryNavigationSkeletonItems = (count: number) => (
  Array.from({ length: count }, (_, index) => index)
);

export const getSecondaryNavigationTextTooltipTitle = (content: ReactNode) => (
  typeof content === 'string' ? content : ''
);

export const getSecondaryNavigationAllocationStatusBadgeConfig = (status: number) => {
  if (status === ALLOCATIONS_FINAL) {
    return { label: 'Final', tone: 'final' as SecondaryNavigationStatusBadgeTone };
  }

  if (status === ALLOCATIONS_PUBLISHED) {
    return { label: 'Published', tone: 'published' as SecondaryNavigationStatusBadgeTone };
  }

  if (status === ALLOCATIONS_DRAFT) {
    return { label: 'Draft', tone: 'draft' as SecondaryNavigationStatusBadgeTone };
  }

  return { label: 'Draft', tone: 'draft' as SecondaryNavigationStatusBadgeTone };
};
